import type React from "react";
import { AiOutlineProject } from "react-icons/ai";
import { GiProgression } from "react-icons/gi";
import { IoIosArrowBack } from "react-icons/io";
import { MdOutlineLocalActivity, MdOutlinePlayLesson } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Avatar } from "rsuite";
import type { LessonType } from "../../../entities/Lesson/types/LessonType";
import "./UpperPart.scss";

type Props = {
	data: LessonType;
};

const UpperPart: React.FC<Props> = ({ data }) => {
	const stats = [
		{
			icon: <MdOutlinePlayLesson />,
			info: "4/76 lessons",
		},
		{
			icon: <MdOutlineLocalActivity />,
			info: "2/35 practical works",
		},
		{
			icon: <GiProgression />,
			info: "5/100 progress",
		},
		{
			icon: <AiOutlineProject />,
			info: "0/1 final project",
		},
	];

	const navigate = useNavigate();

	const goBack = () => {
		navigate(-1);
	};
	return (
		<div
			style={{
				backgroundImage: `url(${data?.image})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "100%",
			}}
			className="lesson-details__upper-image"
		>
			<button
				type="button"
				onClick={goBack}
				className="lesson-details__go-back"
			>
				<IoIosArrowBack /> <p>Courses</p>
			</button>
			<p className="lesson-details__title">{data?.name}</p>
			<div className="lesson-details__avatar-container">
				<Avatar
					className="lesson-details__avatar"
					size="md"
					circle
					src="https://avatars.githubusercontent.com/u/12592949"
					alt="@superman66"
				/>
				<p>Nazim</p>
			</div>
			<div className="lesson-details__stats-and-progress">
				<div className="lesson-details__stats">
					{stats.map((stat) => (
						<div key={stat.info} className="lesson-details__stat">
							<span className="lesson-details__stat-icon">{stat.icon}</span>
							<span className="lesson-details__stat-info">{stat.info}</span>
						</div>
					))}
				</div>
				<div className="lesson-details__progress-bar">
					<div className="lesson-details__internal-progress" />
				</div>
			</div>
		</div>
	);
};

export default UpperPart;
